import React from 'react';

import Byline from '@components/Byline';
import SearchIcon from '@components/Images/SearchIcon';
import { dateInLocalTimezone } from '@utils/dates';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

import ConfidenceLevel from './ConfidenceLevel';
import { HeaderProps, SEARCH_PLACEHOLDER } from './interface';

const Header = ({ onSearchChange, project, searchQuery, unlocked }: HeaderProps) => {
  const { description, updatedAt, title, authors } = project;

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-4 md:gap-16">
        <header className="md:col-span-3">
          <h1 className="m-0 font-suisse-works text-headline-xs sm:text-headline-xl">{title}</h1>
          {description && (
            <div className="mb-0 mt-24 font-noto-serif text-body-articles text-primary-black">
              {AuthoredContentReactToHtmlParser(description)}
            </div>
          )}
          <div className="mt-24 flex items-center justify-between">
            <div>
              {authors.length > 0 && <Byline authors={authors} />}
              {updatedAt && (
                <p className="mb-0 mt-0 font-suisse-screen text-byline-sm italic text-primary-black">
                  Last updated {dateInLocalTimezone(updatedAt)}
                </p>
              )}
            </div>
          </div>
        </header>
        <aside className="mt-32 flex flex-col items-start justify-center border-0 border-solid border-grayscale-gray md:mt-0 md:border-l md:pl-32 lg:pl-40">
          <div className="relative w-full max-w-[270px] md:max-w-none">
            <label className="sr-only" htmlFor="influential-search">
              Search name or title
            </label>
            <input
              className="h-40 w-full border-2 border-solid border-grayscale-gray bg-white py-0 pl-12 pr-40 font-suisse-screen text-form text-primary-black outline-none placeholder:text-grayscale-gray"
              id="influential-search"
              disabled={!unlocked}
              name="search"
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder={SEARCH_PLACEHOLDER}
              type="text"
              value={searchQuery}
            />
            <SearchIcon
              className="pointer-events-none absolute right-12 top-1/2 h-20 w-20 -translate-y-1/2 text-primary-black"
              data-testid="search-icon"
            />
          </div>
          <div className="mt-32">
            <ConfidenceLevel className="mb-12" confidenceLevel={3} />
            <h2 className="mb-4 mt-0 font-noto-serif text-body-lg text-primary-black">
              Debate Meter
            </h2>
            <p className="mb-0 mt-0 font-suisse-screen text-disclosure-sm text-grayscale-charcoal">
              A measure of how long we deliberated over a choice: Those with one bar took almost no
              time. Two bars took a moderate amount of time. Those with three bars required the
              deepest consideration.
            </p>
          </div>
        </aside>
      </div>
    </>
  );
};

export default Header;
